import React from "react";
import { ApplicationConfigure } from "./ApplicationConfigure";
import { PeripheralConfiguration } from "./PeripheralConfigure";

function View(props: any) {
    const {
        displayMode,
        t,
        setIsAddAppClicked,
        isAddAppClicked,
        setGlobalDataIsUpdated,
        isAddNewAppButtonClicked,
        selectedRows,
        editedData,
        isComingFromModify,
        inputDesignation,
        setInputDesignation,
        setIsConfirmationEditModalOpened,
        data,
        isConsult,
        setIsConsult,
        shopIds,
        setSelectedRows,
        setEditedData,
        setIsEdited,
        isEdited,
    } = props;

    if (displayMode !== t("View by device")) {
        // ! Affichage par Application
        return (
            <ApplicationConfigure
                setIsAddAppClicked={setIsAddAppClicked}
                isAddAppClicked={isAddAppClicked}
                setDataIsUpdated={setGlobalDataIsUpdated}
                isAddNewAppButtonClicked={isAddNewAppButtonClicked}
                selectedRows={
                    !isComingFromModify ? selectedRows[0] : editedData
                }
                isComingFromModify={isComingFromModify}
                inputDesignation={inputDesignation}
                setInputDesignation={setInputDesignation}
                setIsConfirmationEditModalOpened={
                    setIsConfirmationEditModalOpened
                }
                data={data}
                isConsult={isConsult}
                setIsConsult={setIsConsult}
                shopIds={shopIds}
                setSelectedRows={setSelectedRows}
            />
        );
    }

    if (displayMode === t("View by device")) {
        // ! Affichage par Périphérique
        return (
            <PeripheralConfiguration
                setIsAddPeripheralClicked={setIsAddAppClicked}
                isAddPeripheralClicked={isAddAppClicked}
                setDataIsUpdated={setGlobalDataIsUpdated}
                isAddNewPeripheralButtonClicked={isAddNewAppButtonClicked}
                selectedRows={
                    !isComingFromModify
                        ? selectedRows.filter(
                              (el: any) => el[t("Shop")] !== ""
                          )[0]
                        : editedData
                }
                isComingFromModify={isComingFromModify}
                setEditedData={setEditedData}
                setIsEdited={setIsEdited}
                isEdited={isEdited}
                editedData={editedData}
                shopIds={shopIds}
                data={data}
                isConsult={isConsult}
                setIsConsult={setIsConsult}
            />
        );
    }

    return null;
}

export default View;
